var exports = {
  "U": "VoiceSceneAvatar.module__camera___REJCcy",
};

module.exports = exports;
